<template>
    <div>
        <div class="container new-session px-4 py-4">
            <div v-if="showCreationWarning" class="notification is-warning">
                <button
                    class="delete"
                    @click="showCreationWarning = false"
                ></button>
                <p v-t="'Sessions.creation_warning'"></p>
            </div>
            <div v-if="showCreationError" class="notification is-danger">
                <button class="delete" @click="showCreationError = false"></button>
                {{ creationError }}
            </div>
            <div
                v-if="!$store.getters.projectContent.length"
                class="notification is-danger"
            >
                <p v-t="'Sessions.creation_empty_project'"></p>
            </div>

            <form class="">
                <div class="columns is-mobile is-vcentered is-multiline">
                    <div class="column is-12">
                        <div class="field mb-5">
                            <label
                                v-t="'Sessions.session_name'"
                                class="label"
                            ></label>
                            <div class="control">
                                <input
                                    v-model="title"
                                    :placeholder="$t('Sessions.session_name')"
                                    class="input"
                                    type="text"
                                />
                            </div>
                        </div>

                        <div class="field">
                            <label
                                v-t="'Sessions.show_at_end'"
                                class="label"
                            ></label>
                            <div class="control is-expanded">
                                <textarea
                                    rows="3"
                                    v-model="configuration.feedback"
                                    :placeholder="$t('Sessions.end_of_game_info')"
                                    class="textarea has-fixed-size"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <label
                            v-t="'Sessions.play_mode_select'"
                            for="appmode"
                            class="label"
                        ></label>
                        <div class="level is-mobile mb-2">
                            <div class="level-item mr-0">
                                <span
                                    ref="appButton"
                                    class="
                                        button
                                        is-light is-fullwidth
                                        has-tooltip-bottom has-tooltip-multiline
                                    "
                                    :data-tooltip="
                                        $t(`Sessions.play_mode_select_app`)
                                    "
                                    @click.stop="setApp"
                                >
                                    <span class="icon is-small">
                                        <i
                                            class="
                                                mdi mdi-18px mdi-tablet-cellphone
                                            "
                                        ></i>
                                    </span>
                                    <span>APP</span>
                                </span>
                            </div>
                            <div class="level-item mr-0">
                                <span
                                    ref="webButton"
                                    class="
                                        button
                                        is-light is-primary is-fullwidth
                                        has-tooltip-bottom has-tooltip-multiline
                                    "
                                    :data-tooltip="
                                        $t(`Sessions.play_mode_select_web`)
                                    "
                                    @click.stop="setWeb"
                                >
                                    <span class="icon is-small">
                                        <i class="mdi mdi-18px mdi-laptop"></i>
                                    </span>
                                    <span>WEB</span>
                                </span>
                            </div>
                        </div>

                        <label
                            v-if="configuration.app"
                            v-t="'Sessions.play_mode_select_app_hint'"
                            for="appmode"
                            class="label is-italic"
                        ></label>
                        <label
                            v-else
                            v-t="'Sessions.play_mode_select_web_hint'"
                            for="appmode"
                            class="label is-italic"
                        ></label>

                        <div class="field mb-3 pt-4" v-if="isModeMap">
                            <label class="switch">
                                <input
                                    id="closer"
                                    v-model="configuration.closer"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <label
                                v-t="'Sessions.have_to_be_close'"
                                for="closer"
                                class="pl-3"
                            ></label>
                        </div>

                        <div class="field pt-4">
                            <label class="switch">
                                <input
                                    id="allowsReset"
                                    v-model="allowsReset"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <label
                                v-t="'Sessions.allows_reset'"
                                for="allowsReset"
                                class="pl-3"
                            ></label>
                        </div>
                    </div>
                </div>

                <hr />

                <div class="columns is-mobile is-vcentered is-multiline">
                    <div class="column is-12 pb-0">
                        <div class="field mb-3 mt-3">
                            <label class="switch">
                                <input
                                    id="availability"
                                    v-model="configuration.availability"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <label
                                v-t="'Sessions.game_availability'"
                                for="availability"
                                class="pl-3"
                            ></label>
                        </div>
                    </div>
                </div>

                <div
                    class="columns is-mobile is-vcentered is-multiline"
                    v-if="limitedAvailability"
                >
                    <div class="column is-12 pt-4">
                        <div class="field">
                            <label
                                v-t="'Sessions.start_date'"
                                class="label"
                            ></label>
                            <div class="field-body">
                                <InputDatetime
                                    v-model="configuration.startDate"
                                    :min-date="minDate"
                                ></InputDatetime>
                            </div>
                        </div>
                    </div>

                    <div class="column is-12 pt-0">
                        <div class="field">
                            <label
                                v-t="'Sessions.limit_date'"
                                class="label"
                            ></label>
                            <div class="field-body">
                                <InputDatetime
                                    v-model="configuration.limitDate"
                                    :min-date="minDate"
                                ></InputDatetime>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
        <div class="action-buttons-container mb-2">
            <div class="tabs is-toggle is-fullwidth has-background-white mt-4 ">
                <ul >
                    <li>
                        <a @click="discardUnsavedChanges">
                            <span class="icon is-small my-2"><i class="mdi mdi-24px mdi-chevron-left" aria-hidden="true"></i></span>
                        </a>
                    </li>
                    <li>
                        <a @click="createSession"> 
                            <span class="icon is-small my-2 "><i class="mdi mdi-24px mdi-content-save-outline" aria-hidden="true"></i></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { createItem } from '@/services/API';
import InputDatetime from '@/components/InputDatetime';
import moment from 'moment';
import _ from 'underscore';
export default {
    components: {
        InputDatetime,
    },
    data() {
        return {
            creating: false,
            allowsReset: false,
            showCreationWarning: true,
            showCreationError: false,
            creationError: false,
            minDate: moment().toISOString(),
            configuration: {
                mode: this.isModeMap != true ? 'TRIVIAL' : 'MAP',
                time: 2,
                timeUnits: 'minutes',
                closer: false,
                availability: false,
                app: false,
                web: true,
            },
            title:
                this.$store.getters.project.type == 'treasurehunt'
                    ? this.$t('Sessions.treasurehunt_title_suggestion') +
                      this.$store.getters.project.title
                    : this.$t('Sessions.quiz_title_suggestion') +
                      this.$store.getters.project.title,
        };
    },
    computed: {
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
        objects() {
            return this.$store.getters.projectContent;
        },
        limitedAvailability() {
            return this.configuration.availability;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map';
        },
    },
    methods: {
        async createSession() {
            // console.log("createsession")
            this.creating = true;
            this.showCreationError = false;
            this.creationError = undefined;
            if (this.isModeMap == true && this.isTrivial) {
                const objectsContainsLocation = _.every(
                    this.objects,
                    (object) => {
                        return object.location;
                    }
                );
                if (!objectsContainsLocation) {
                    this.showCreationError = true;
                    this.creating = false;
                    return (this.creationError = this.$t(
                        'Sessions.error_objects_without_location'
                    ));
                }
                if (this.configuration.mode == 'TRIVIAL') {
                    // console.log('forcing change');
                    this.configuration.mode = 'MAP';
                }
            }
            let session = await createItem('session', {
                configuration: this.configuration,
                project: this.$store.getters.project._id,
                title: this.title,
                shortCode: this.code,
                allowsReset: this.allowsReset,
            });
            this.creating = false;
            this.$store.dispatch('setSession', session.data).catch((e) => {
                this.creating = false;
                this.creationError = e;
                this.showCreationError = true;
            });
            this.$emit('detail');
            this.$emit('close');
        },
        setApp() {
            this.configuration.app = true;
            this.configuration.web = false;
            if (!this.$refs.appButton.classList.contains('is-primary')) {
                this.$refs.appButton.classList.add('is-primary');
                this.$refs.webButton.classList.remove('is-primary');
            }
        },
        setWeb() {
            this.configuration.app = false;
            this.configuration.web = true;
            if (!this.$refs.webButton.classList.contains('is-primary')) {
                this.$refs.webButton.classList.add('is-primary');
                this.$refs.appButton.classList.remove('is-primary');
            }
        },
        discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },
    },
};
</script>

<style scoped>
.new-session {
    overflow-y: auto;
    max-height: calc(100vh - 95px);
    overflow-x: hidden;
}
.action-buttons-container {
    position: absolute;
    bottom:1.9rem;
    height: 50px;
    width: 100%;

}
</style>
